<div class="flex-col gap-10">
    <!-- Image Carousel -->
    <!-- <div style="width: 100%">
        <mat-carousel [hideArrows]="false" [hideIndicators]="false" aria-hidden="true">
            @for (slide of slides; track $index) {
                <mat-carousel-slide #matCarouselSlide [image]="slide.image" />
            }
        </mat-carousel>
    </div> -->

    <div class="flex-container" data-cy="sportCardArea">
        @for (card of sportbereiche; track $index) {
            <kkm-infocard class="flex-1" [roundImage]="true" [data]="card" data-cy="sportCard" />
        }
    </div>

    <div style="text-align: center">
        <h2>Aktuelles / Berichte aus dem Vereinsleben</h2>
    </div>

    <div class="flex-container" data-cy="newsCardArea">
        @if (isLoading()) {
            <mat-spinner class="spinner"></mat-spinner>
        } @else {
            @for (card of news(); track $index) {
                <kkm-infocard class="flex-1" [data]="card" [truncate]="true" data-cy="newsCard" />
            }
        }
    </div>
</div>

